import React from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

export default ({ children, loading, spinnerProps, ...props }) =>
  <Button {...props}>
    {children}
    {loading && <CircularProgress size={12} style={{ margin: 2, marginLeft: 4 }} {...spinnerProps} />}
  </Button>
